export default "__VITE_ASSET__DPr7KeE5__"